// giusp.com grn@giusp.com

import { pass, neutral, fail, styleAsIsValid, styleAsIsInvalid } from "./service_commons.js";

let inputElement1Name = "serviceInput";

function precheck_inputElement1(inputElement1) {
    let n = inputElement1.value;

    if ((n === "" || n == null) || (!/^[0-9]+$/.test(n))) {
        fail("first");
        neutral("second");
        return false;
    }

    pass("first");
    neutral("second");

    n = parseInt(n);

    if (n > Math.pow(10, 18)) {
        fail("second");
        return false;
    }

    pass("second");
    return true;
}

function precheckStyle_inputElement1(inputElement1) {
    if (precheck_inputElement1(inputElement1)) {
        styleAsIsValid(inputElement1);
    } else {
        styleAsIsInvalid(inputElement1);
    }
}

document.getElementById(inputElement1Name).oninput = function () {
    precheckStyle_inputElement1(this);
};

window.onload = function () {
    let res = precheck_inputElement1(document.getElementById(inputElement1Name));

    if (res) {
        document.getElementById("serviceFormSendButton").removeAttribute("disabled");
    } else {
        document.getElementById("serviceFormSendButton").setAttribute("disabled",
            "disabled");
    }
};
